export const aupCodeCopy = {
  header: '',
  description400: '',
  description500: '',
  ok: '',
  messageSent: '',
};
